<template>
  <div class="library-header">
    <AppMenuItem
      v-for="menuItem in menuItems"
      :key="menuItem.link"
      :icon="menuItem.icon"
      :link="menuItem.link"
      :text="menuItem.text"
      :isActive="routeName === menuItem.link"
      :stackOnMobile="false"
      :class="{
        'library-header__item': true,
        'library-header__item--active': routeName === menuItem.link,
      }"
    />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import AppMenuItem from '@/app/components/header/AppMenuItem.vue'
import { computed } from 'vue'

const router = useRouter()
const routeName = computed(() => router.currentRoute.value.name)

type MenuItem = {
  text: string
  link: string
  icon: string
}
const menuItems: MenuItem[] = [
  {
    text: 'Books',
    link: 'my_library.books',
    icon: 'ibook',
  },
  {
    text: 'Articles',
    link: 'my_library.articles',
    icon: 'iarticles',
  },
  {
    text: 'Podcasts',
    link: 'my_library.episodes',
    icon: 'ipodcasts',
  },
  {
    text: 'Lists',
    link: 'my_library.custom_lists',
    icon: 'iflag',
  },
]
</script>

<style lang="scss" scoped>
.library-header {
  display: flex;
  justify-content: center;
  gap: 40px;
  background-color: $c-bg;
  @media only screen and (max-width: $w-tablet-s) {
    justify-content: flex-start;
    padding: 0;
  }

  &__item {
    color: $c-black-3;
    @media only screen and (max-width: $w-tablet-s) {
      flex-grow: 0;
    }

    &--active {
      color: $c-black-2;
    }
  }
}

.night-mode .library-header {
  background-color: $c-bg-5;

  &__item {
    color: $c-dark-8;

    &--active {
      color: $c-white;
    }
  }
}
</style>
